define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/MenuItem",
    "dijit/MenuSeparator",
    "csi/widget/Select",
    "dojo/text!./resources/Select.html",
    "dojo/text!./resources/MenuItem.html"
], function (declare, lang, MenuItem, MenuSeparator, Select, template, menuItemTemplate) {

    return declare([Select], {
        templateString: template,

        _getMenuItemForOption: function (/*_FormSelectWidget.__SelectOption*/ option) {
            // summary:
            //		For the given option, return the menu item that should be
            //		used to display it.  This can be overridden as needed
            if (!option.value && !option.label) {
                // We are a separator (no label set for it)
                return new MenuSeparator({ ownerDocument: this.ownerDocument });
            } else {
                // Just a regular menu option
                var click = lang.hitch(this, "_setValueAttr", option);
                var item = new MenuItem({
                    option: option,
                    label: (this.labelType === 'text' ? (option.label || '').toString()
                        .replace(/&/g, '&amp;').replace(/</g, '&lt;') :
                        option.label) || this.emptyLabel,
                    onClick: click,
                    ownerDocument: this.ownerDocument,
                    dir: this.dir,
                    templateString: menuItemTemplate,
                    textDir: this.textDir,
                    disabled: option.disabled || false
                });
                item.focusNode.setAttribute("role", "option");
                return item;
            }
        }

    });
});
